import React, { useState, useEffect, Fragment } from "react";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import { useMediaQuery } from "react-responsive";
import GroupList from "../group_list/group_list";
import RecentPost from "../recent_post/recent_post";
import PopularGroup from "../popular_group/popular_group";
import OtherTopic from "../other_topic/other_topic";
import styles from "./forum_container.module.scss";
import { GroupHeading } from "@modules/forum/group/component";
import { BiMenuAltLeft } from "react-icons/bi";
import { FiArrowLeft, FiChevronRight, FiX } from "react-icons/fi";

const ForumContainer = ({
  navigationFalse,
  children,
  groupList,
  popularGroup,
  groupTopic,
  groupDetails,
  recentPost,
  ...props
}) => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const toggleDrawer = (newOpen) => () => {
    setDrawerOpen(newOpen);
  };
  const isMobile = useMediaQuery({
    query: "(max-width: 991px)",
  });

  const LeftContent = () => {
    return (
      <>
        <GroupList groupList={groupList} />
        <RecentPost recentPost={recentPost} />
      </>
    );
  };
  const RightContent = () => {
    return (
      <>
        <PopularGroup popularGroup={popularGroup} />
        <OtherTopic groupTopic={groupTopic} />
      </>
    );
  };

  return (
    <Fragment>
      <div className={styles.forum_wrapper}>
        <div className="container">
          {isMobile && (
            <button
              className={styles.btn_open_drawer}
              onClick={() => setDrawerOpen(true)}
            >
              <FiChevronRight />
            </button>
          )}
          {!navigationFalse && <GroupHeading groupDetails={groupDetails} />}
          <div className={styles.content_container}>
            <div className={styles.content_left}>
              <LeftContent />
            </div>
            <div className={styles.content_center}>{children}</div>
            <div className={styles.content_right}>
              <RightContent />
            </div>
          </div>
        </div>
      </div>

      {isMobile && (
        <SwipeableDrawer
          anchor="left"
          classes={{ paper: "ForumSideDrawer" }}
          open={drawerOpen}
          onClose={toggleDrawer(false)}
          onOpen={toggleDrawer(true)}
          disableSwipeToOpen={false}
          ModalProps={{ keepMounted: true }}
        >
          <div className={styles.forum_drawer_wrapper}>
            <div className={styles.drawer_header_wrapper}>
              <FiX
                className={styles.left_arrow}
                onClick={() => setDrawerOpen(false)}
              />
            </div>
            <div className={styles.drawer_content_wrapper}>
              <LeftContent />
              <RightContent />
            </div>
          </div>
        </SwipeableDrawer>
      )}
    </Fragment>
  );
};

export default ForumContainer;
